// apps/roleforge-app/src/components/audit/RightColumnTabs.tsx
//
// Phase 11 — wraps the right column of the owner audit shell with two tabs:
// "Assets" (default — the existing AssetsColumn) and "Voices" (new — VoicesTab
// listing per-voice contribution threads).

import { useState, type ReactNode } from 'react';

interface Props {
  assetsContent: ReactNode;
  voicesContent: ReactNode;
}

export function RightColumnTabs({ assetsContent, voicesContent }: Props) {
  const [tab, setTab] = useState<'assets' | 'voices'>('assets');
  return (
    <aside className="flex h-full flex-col border-l border-line bg-paper">
      <div
        role="tablist"
        className="flex border-b border-line text-[11px] font-semibold uppercase tracking-wider text-graphite"
      >
        <button
          role="tab"
          aria-selected={tab === 'assets'}
          onClick={() => setTab('assets')}
          className={`flex-1 px-4 py-3 ${
            tab === 'assets' ? 'text-ink border-b-2 border-coral' : ''
          }`}
        >
          Assets
        </button>
        <button
          role="tab"
          aria-selected={tab === 'voices'}
          onClick={() => setTab('voices')}
          className={`flex-1 px-4 py-3 ${
            tab === 'voices' ? 'text-ink border-b-2 border-coral' : ''
          }`}
        >
          Voices
        </button>
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto">
        {tab === 'assets' ? assetsContent : voicesContent}
      </div>
    </aside>
  );
}
